import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import Integration from "./style"
import SignupButton from "./SignupButton"
import SectionTitle from './Components/SectionTitle'
const IntegrationSection = ({ ...rest }) => {
  return (
    <Integration
      backgroundColor="#f2f5fb"
    >
      <Container>
        <Row className="row justify-content-center">
          <Col className="col-xl-10">
            <Integration.Box className="text-center">
              <SectionTitle
                title="Sign up to automate your document workflow today."
                text="Everything you need in one unified platform."
              />
            </Integration.Box>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col xs="12" className="col-xl-5 col-lg-6 col-md-9">
            <SignupButton btnText="Sign up for early access" btnLink="/early-access" />
          </Col>
        </Row>
      </Container>
    </Integration>
  )
}

export default IntegrationSection
